import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {UnregisterRoutingModule} from './unregister-routing.module';
import {UnregisterComponent} from './unregister.component/unregister.component';
import {UnregisterRepository} from './repositories/unregister.repository';
import {UnregisterService} from './services/unregister.service';
import { ThanksComponent } from './thanks.component/thanks.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UnregisterRoutingModule,
  ],
  declarations: [
    UnregisterComponent,
    ThanksComponent,
  ],
  providers: [
    UnregisterService,
    {
      provide: 'IUnregisterRepository',
      useClass: UnregisterRepository,
    },
  ],
  exports: [
    UnregisterComponent,
  ],
})

export class UnregisterModule { }
